import { BasicResponseDTO } from "./basicResponse.dto";

export class CreateMailGroupDTO {
  label?: string;
  mails?: string[];
  group_id?: number;
  send_ok?: boolean;
  include_tags?: boolean;
  send_per_item?: boolean;
}

export class MailGroup extends CreateMailGroupDTO {
  mail_group_id: number;
  user_id?: number;
  username?: string;

  static sorter(a: MailGroup, b: MailGroup) {
    return a?.label?.localeCompare(b?.label);
  }
}

export class MailGroupsResponseDTO extends BasicResponseDTO {
  data: MailGroup[];
}

export class MailGroupResponseDTO extends BasicResponseDTO {
  data: MailGroup;
}